module.exports = __webpack_public_path__ + "static/media/techimage.6749a449.png";